import PropTypes from "prop-types";
import Link from "./link";
import React, { useContext, useEffect, useState } from "react";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/GlobalContextProvider";
import classNames from "classnames";
import Collapse from "./wrappers/collapse";
import { graphql, navigate } from "gatsby";
import mail_icon from "../images/mail_icon.svg";
import mail_icon_white from "../images/mail_icon_white.svg";
import phone_icon from "../images/phone_icon.svg";
import phone_icon_white from "../images/phone_icon_white.svg";
import { isMobile, normalizePath } from "../utils";
import { domain } from "../utils";
import AnchorNavigation from "./anchorNav";

const getSVG = () => {
  return (
    <svg className="close" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <path d="M20.0013 38.3337C30.1265 38.3337 38.3346 30.1255 38.3346 20.0003C38.3346 9.8751 30.1265 1.66699 20.0013 1.66699C9.87608 1.66699 1.66797 9.8751 1.66797 20.0003C1.66797 30.1255 9.87608 38.3337 20.0013 38.3337Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M25.5 14.5L14.5 25.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.5 14.5L25.5 25.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
};

function SiteHeader ({ header, withNavigation, showWhiteIcon, redirectTo, showX, isImage, showBlackNav }) {
  const dispatch = useContext(GlobalDispatchContext);
  const state = useContext(GlobalStateContext);
  const lastVisitedPage = state.lastVisitedPage; 
  const [scrollPos, setScrollPos] = useState(0);
  const isDocumentDefined = typeof document !== "undefined";
  const offset = isDocumentDefined ? document.body.offsetWidth - document.body.clientWidth : 0;
  const [offsetPadding, setOffsetPadding] = useState(offset);
  const [activeMainPath, setActiveMainPath] = useState("");
  const [activeSubPath, setActiveSubPath] = useState("");
  const [activeMainIndex, setActiveMainIndex] = useState(undefined);

  const [isServicesLandingPages, setServicesLandingPage] = useState(false);
  const isWindowDefined = typeof window !== "undefined";
  const { name, nameScroll, menu, language } = header;
  const isOpen = state.siteSubNav;
  const isEnglishHomepage = isWindowDefined && window.location.pathname === "/en";
  const isGermanHomePage = isWindowDefined && window.location.pathname === "/de";
  const isEnglishPage = (isWindowDefined) && window.location.pathname.startsWith("/en");

  const checkpageUrl = () => {
    if (isWindowDefined) {
      const pageUrl = window.location.pathname;
      const regex = /\/services\/(.+)/; // Regex pattern
      const match = regex.exec(pageUrl);

      if (match && match[1].length > 0) {
        setServicesLandingPage(true);
        return;      
      } 
    }
    setServicesLandingPage(false);
    return;
  }
  
  const closeNav = () => {
    dispatch({ type: "CLOSE_SITE_NAV" });
  };

  const toggleIsOpen = (id) => {
    dispatch({ 
      type: "TOGGLE_SITE_SUB_NAV" , 
      payload: {
        id: id
      } 
    });
  };

  const handleClick = () => {
    dispatch({ type: "RESET_SITE_SUB_NAV"});
  };

  useEffect(() => {
    if (isWindowDefined) {
      menu.forEach(({ link, subLinks }, index) => {
        const currentPath = normalizePath(window.location.pathname);
        
        if (link.slug && currentPath.includes(link.slug)) {
          setActiveMainPath(link.slug);
        }
        if (subLinks && subLinks.length > 0 ) {
          subLinks.forEach(({ slug }) => {
            if (slug && currentPath.includes(slug)) {
              setActiveSubPath(slug);
            } 
            if (currentPath.includes(slug)) {
              setActiveMainIndex(index);
            }
          })
        }
      });
    }
  }, [menu, isWindowDefined]);

  useEffect(() => {
    checkpageUrl();

    const handleScroll = () => {
      setScrollPos(
        isDocumentDefined ? document.body.scrollTop : 0
      ); // TODO - Throttle to optimize
    };
    document.body.addEventListener("scroll", handleScroll);

    // Add spacing for body scrollbar...
    const handleResize = () => {
      setOffsetPadding(
        isDocumentDefined
          ? document.body.offsetWidth - document.body.clientWidth
          : 0
      );
    };
    
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
    setTimeout(() => {
      handleResize();
    }, 100);

    return () => {
       isDocumentDefined &&
        document.body.removeEventListener("scroll", handleScroll);
       isDocumentDefined &&
        document.body.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header
        className={classNames("site-header", 
        {"site-header--shadow": isImage}, 
        {"site-header--shadow-hide": isImage && scrollPos > 0}, 
        {"site-header--dark": showBlackNav}
        )}
        data-trigger-push="nav"
      >
        <div className="container">
          <div className="row no-gutters">
            <div className="col-3">
              <div className="site-header__logo">
                <div className="logo" role="banner">
                  <Link
                    className={classNames("logo__link", {
                      scrolled: scrollPos > 0,
                    })}
                    state={{ preserveScrollPosition: true }}
                    to={`/${language}`}
                    title="A fancy SEO title"
                    onClick={() => handleClick()}
                  >
                    <span className="logo__label">{name}</span>
                    <span className="logo__label">{nameScroll}</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-9 site-header__right">
              <div className="site-header__navigation">
                <div className="navigation">
                  {/* START || Navigation toggle*/}

                  <div className="navigation__button-wrap">
                    {/* {isServicesLandingPages && (
                        <div className="navigation__contact-wrapper">
                          <a href="tel:+493050567167" className="navigation__contact-phone">
                            {showWhiteIcon ? (
                              <span><img src={phone_icon_white} loading="lazy"/></span>
                              ) : (
                              <span><img src={phone_icon} loading="lazy"/></span>
                              )}
                              <span className="phone-num"> 030 / 505 671 67 </span>
                          </a>
                          {serviceEmail && (
                            <a href={`mailto:${serviceEmail}`} className="navigation__contact-email">
                            {showWhiteIcon ? (
                            <span className="email-label"> <img src={mail_icon_white} loading="lazy"/> </span>
                            ) : (
                            <span className="email-label"> <img src={mail_icon} loading="lazy"/> </span>
                            )}
                            <span className="email"> <span>{serviceEmail}</span> </span>
                          </a>
                          )}

                        </div>
                    )}  */}
                    {!showX && (
                      <button
                        className={classNames("navigation__button", {
                          open: state.siteNav.isOpen,
                        })}
                        role="button"
                        type="menu"
                        onClick={() => {
                            !isEnglishHomepage &&
                            dispatch({ type: "TOGGLE_SITE_NAV" });
                        }}
                      >
                        <span className="navigation__button--open">
                          <>
                            {isEnglishHomepage ? (
                              <>
                                {!isEnglishPage ? (
                                  <Link to={redirectTo  && !(redirectTo.indexOf("undefined") > 0) ? redirectTo : "/en"}>
                                    <span className="globe">
                                      <svg
                                        width="20"
                                        height="22"
                                        viewBox="0 0 20 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.2344 13.75H13.6869L13.7319 13.2998C13.8022 12.5966 13.875 11.8361 13.875 11C13.875 10.2028 13.8028 9.44463 13.7331 8.7127L13.7321 8.7026L13.689 8.25H13.2344H6.73047H6.27583L6.23272 8.7026L6.23176 8.71271C6.16205 9.44464 6.08984 10.2028 6.08984 11C6.08984 11.8361 6.16264 12.5966 6.23295 13.2998L6.27798 13.75H6.73047H13.2344ZM19.1644 8.61264L19.0607 8.25H18.6836H14.3594H13.8095L13.8616 8.7974C13.9322 9.5389 14 10.254 14 11C14 11.7462 13.9321 12.4979 13.8619 13.2002L13.8069 13.75H14.3594H18.6836H19.0556L19.1625 13.3937C19.3885 12.6405 19.5 11.8535 19.5 11C19.5 10.1794 19.3879 9.39488 19.1644 8.61264ZM18.332 8.125H19.0743L18.7954 7.43715C17.6807 4.68755 15.3054 2.61175 12.4151 1.8336L11.0366 1.46246L11.8823 2.6126C12.6974 3.72106 13.3806 5.53407 13.7249 7.70338L13.7919 8.125H14.2188H18.332ZM13.0938 8.125H13.684L13.5869 7.5428C13.3692 6.23657 13.0062 5.07385 12.605 4.12549L12.6021 4.11869L12.5991 4.11199C12.201 3.24338 11.7806 2.57604 11.2871 2.12361L11.2871 2.12361L11.2856 2.12222C10.863 1.73805 10.4298 1.5 10 1.5C9.54099 1.5 9.10893 1.73163 8.67929 2.12222L8.67929 2.12221L8.67776 2.12361C8.18421 2.57604 7.76389 3.24338 7.36578 4.11199L7.3627 4.11869L7.35983 4.12549C6.9586 5.07385 6.5956 6.23657 6.3779 7.5428L6.28086 8.125H6.87109H13.0938ZM1.16944 7.43715L0.890584 8.125H1.63281H5.74609H6.17299L6.23991 7.70338C6.58425 5.53407 7.26747 3.72106 8.08251 2.6126L8.9282 1.46246L7.5497 1.8336C4.65943 2.61175 2.28415 4.68755 1.16944 7.43715ZM6.10322 8.7974L6.15535 8.25H5.60547H1.28125H0.904099L0.800488 8.61264C0.573032 9.40873 0.5 10.1961 0.5 11C0.5 11.8361 0.572416 12.6273 0.802337 13.3937L0.909235 13.75H1.28125H5.60547H6.15796L6.10299 13.2002C6.03275 12.4979 5.96484 11.7462 5.96484 11C5.96484 10.254 6.0326 9.5389 6.10322 8.7974ZM7.35983 17.9097L7.3627 17.9165L7.36578 17.9232C7.76389 18.7918 8.18421 19.4591 8.67776 19.9115L8.67929 19.9129C9.13031 20.323 9.56138 20.5 9.96484 20.5C10.3971 20.5 10.8286 20.3284 11.2856 19.9129L11.2871 19.9115C11.7806 19.4591 12.201 18.7918 12.5991 17.9232L12.6021 17.9165L12.605 17.9097C13.0065 16.9607 13.3697 15.7972 13.5873 14.455L13.6814 13.875H13.0938H6.87109H6.28348L6.37754 14.455C6.59519 15.7972 6.95833 16.9607 7.35983 17.9097ZM7.5497 20.2016L8.9282 20.5727L8.08251 19.4226C7.26785 18.3146 6.58453 16.5021 6.2401 14.2978L6.17404 13.875H5.74609H1.63281H0.894296L1.16857 14.5607C2.28287 17.3464 4.6586 19.4232 7.5497 20.2016ZM11.8823 19.4226L11.0366 20.5727L12.4151 20.2016C15.3062 19.4232 17.682 17.3464 18.7963 14.5607L19.0705 13.875H18.332H14.2188H13.7908L13.7247 14.2978C13.3803 16.5021 12.697 18.3146 11.8823 19.4226Z"
                                          stroke={
                                            showWhiteIcon ? "white" : "black"
                                          }
                                        />
                                      </svg>
                                    </span>
                                    <span>{!isMobile() ? "Englisch" : "EN"}</span>
                                  </Link>
                                ) : (
                                  <Link to={redirectTo  && !(redirectTo.indexOf("undefined") > 0) ? redirectTo : "/de"}>
                                    <span className="globe">
                                      <svg
                                        width="20"
                                        height="22"
                                        viewBox="0 0 20 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.2344 13.75H13.6869L13.7319 13.2998C13.8022 12.5966 13.875 11.8361 13.875 11C13.875 10.2028 13.8028 9.44463 13.7331 8.7127L13.7321 8.7026L13.689 8.25H13.2344H6.73047H6.27583L6.23272 8.7026L6.23176 8.71271C6.16205 9.44464 6.08984 10.2028 6.08984 11C6.08984 11.8361 6.16264 12.5966 6.23295 13.2998L6.27798 13.75H6.73047H13.2344ZM19.1644 8.61264L19.0607 8.25H18.6836H14.3594H13.8095L13.8616 8.7974C13.9322 9.5389 14 10.254 14 11C14 11.7462 13.9321 12.4979 13.8619 13.2002L13.8069 13.75H14.3594H18.6836H19.0556L19.1625 13.3937C19.3885 12.6405 19.5 11.8535 19.5 11C19.5 10.1794 19.3879 9.39488 19.1644 8.61264ZM18.332 8.125H19.0743L18.7954 7.43715C17.6807 4.68755 15.3054 2.61175 12.4151 1.8336L11.0366 1.46246L11.8823 2.6126C12.6974 3.72106 13.3806 5.53407 13.7249 7.70338L13.7919 8.125H14.2188H18.332ZM13.0938 8.125H13.684L13.5869 7.5428C13.3692 6.23657 13.0062 5.07385 12.605 4.12549L12.6021 4.11869L12.5991 4.11199C12.201 3.24338 11.7806 2.57604 11.2871 2.12361L11.2871 2.12361L11.2856 2.12222C10.863 1.73805 10.4298 1.5 10 1.5C9.54099 1.5 9.10893 1.73163 8.67929 2.12222L8.67929 2.12221L8.67776 2.12361C8.18421 2.57604 7.76389 3.24338 7.36578 4.11199L7.3627 4.11869L7.35983 4.12549C6.9586 5.07385 6.5956 6.23657 6.3779 7.5428L6.28086 8.125H6.87109H13.0938ZM1.16944 7.43715L0.890584 8.125H1.63281H5.74609H6.17299L6.23991 7.70338C6.58425 5.53407 7.26747 3.72106 8.08251 2.6126L8.9282 1.46246L7.5497 1.8336C4.65943 2.61175 2.28415 4.68755 1.16944 7.43715ZM6.10322 8.7974L6.15535 8.25H5.60547H1.28125H0.904099L0.800488 8.61264C0.573032 9.40873 0.5 10.1961 0.5 11C0.5 11.8361 0.572416 12.6273 0.802337 13.3937L0.909235 13.75H1.28125H5.60547H6.15796L6.10299 13.2002C6.03275 12.4979 5.96484 11.7462 5.96484 11C5.96484 10.254 6.0326 9.5389 6.10322 8.7974ZM7.35983 17.9097L7.3627 17.9165L7.36578 17.9232C7.76389 18.7918 8.18421 19.4591 8.67776 19.9115L8.67929 19.9129C9.13031 20.323 9.56138 20.5 9.96484 20.5C10.3971 20.5 10.8286 20.3284 11.2856 19.9129L11.2871 19.9115C11.7806 19.4591 12.201 18.7918 12.5991 17.9232L12.6021 17.9165L12.605 17.9097C13.0065 16.9607 13.3697 15.7972 13.5873 14.455L13.6814 13.875H13.0938H6.87109H6.28348L6.37754 14.455C6.59519 15.7972 6.95833 16.9607 7.35983 17.9097ZM7.5497 20.2016L8.9282 20.5727L8.08251 19.4226C7.26785 18.3146 6.58453 16.5021 6.2401 14.2978L6.17404 13.875H5.74609H1.63281H0.894296L1.16857 14.5607C2.28287 17.3464 4.6586 19.4232 7.5497 20.2016ZM11.8823 19.4226L11.0366 20.5727L12.4151 20.2016C15.3062 19.4232 17.682 17.3464 18.7963 14.5607L19.0705 13.875H18.332H14.2188H13.7908L13.7247 14.2978C13.3803 16.5021 12.697 18.3146 11.8823 19.4226Z"
                                          stroke={
                                            showWhiteIcon ? "white" : "black"
                                          }
                                        />
                                      </svg>
                                    </span>
                                    <span>{!isMobile() ? "German" : "DE"}</span>
                                  </Link>
                                )}
                              </>
                            ) : (
                              "Menu"
                            )}
                          </>
                        </span>
                        <span className="navigation__button--close">Close</span>
                      </button>
                    )}
                    {showX && (
                      <div className="navigation__button">
                        <Link 
                          className={" navigation__button--open"}
                          to={lastVisitedPage || showX.path}
                        >
                          {getSVG()}
                        </Link>
                      </div>
    
                    )}
                    {/* {isEnglishHomepage && (
                      <div className="navigation__lang">
                        <span className="navigation__lang-de">
                          <Link to="/de">DE</Link>
                        </span>
                        <span className="navigation__lang-slash">|</span>
                        <span className="navigation__lang-en">EN</span>
                      </div>
                    )} */}
                  </div>
                  {/* END || Navigation toggle*/}

                  {withNavigation && (
                    <nav
                      id="navigation_main"
                      role="navigation"
                      className={classNames("navigation__overlay push-nav", {
                        open: state.siteNav.isOpen,
                        opensub: Object.values(isOpen).includes(true),
                      })}
                    >
                      <div
                        className={classNames("navigation__switcher", {
                          active: isEnglishHomepage,
                          active: isGermanHomePage,
                        })}
                        onClick={() => dispatch({ type: "TOGGLE_SITE_NAV" })}
                      >
                        <Link
                          className={classNames("lang", {
                            active: isGermanHomePage,
                          })}
                          to={redirectTo ? redirectTo : (isEnglishPage ? "/de" : "/en")}
                        >
                          <span className="globe">
                            <svg
                              width="20"
                              height="22"
                              viewBox="0 0 20 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.2344 13.75H13.6869L13.7319 13.2998C13.8022 12.5966 13.875 11.8361 13.875 11C13.875 10.2028 13.8028 9.44463 13.7331 8.7127L13.7321 8.7026L13.689 8.25H13.2344H6.73047H6.27583L6.23272 8.7026L6.23176 8.71271C6.16205 9.44464 6.08984 10.2028 6.08984 11C6.08984 11.8361 6.16264 12.5966 6.23295 13.2998L6.27798 13.75H6.73047H13.2344ZM19.1644 8.61264L19.0607 8.25H18.6836H14.3594H13.8095L13.8616 8.7974C13.9322 9.5389 14 10.254 14 11C14 11.7462 13.9321 12.4979 13.8619 13.2002L13.8069 13.75H14.3594H18.6836H19.0556L19.1625 13.3937C19.3885 12.6405 19.5 11.8535 19.5 11C19.5 10.1794 19.3879 9.39488 19.1644 8.61264ZM18.332 8.125H19.0743L18.7954 7.43715C17.6807 4.68755 15.3054 2.61175 12.4151 1.8336L11.0366 1.46246L11.8823 2.6126C12.6974 3.72106 13.3806 5.53407 13.7249 7.70338L13.7919 8.125H14.2188H18.332ZM13.0938 8.125H13.684L13.5869 7.5428C13.3692 6.23657 13.0062 5.07385 12.605 4.12549L12.6021 4.11869L12.5991 4.11199C12.201 3.24338 11.7806 2.57604 11.2871 2.12361L11.2871 2.12361L11.2856 2.12222C10.863 1.73805 10.4298 1.5 10 1.5C9.54099 1.5 9.10893 1.73163 8.67929 2.12222L8.67929 2.12221L8.67776 2.12361C8.18421 2.57604 7.76389 3.24338 7.36578 4.11199L7.3627 4.11869L7.35983 4.12549C6.9586 5.07385 6.5956 6.23657 6.3779 7.5428L6.28086 8.125H6.87109H13.0938ZM1.16944 7.43715L0.890584 8.125H1.63281H5.74609H6.17299L6.23991 7.70338C6.58425 5.53407 7.26747 3.72106 8.08251 2.6126L8.9282 1.46246L7.5497 1.8336C4.65943 2.61175 2.28415 4.68755 1.16944 7.43715ZM6.10322 8.7974L6.15535 8.25H5.60547H1.28125H0.904099L0.800488 8.61264C0.573032 9.40873 0.5 10.1961 0.5 11C0.5 11.8361 0.572416 12.6273 0.802337 13.3937L0.909235 13.75H1.28125H5.60547H6.15796L6.10299 13.2002C6.03275 12.4979 5.96484 11.7462 5.96484 11C5.96484 10.254 6.0326 9.5389 6.10322 8.7974ZM7.35983 17.9097L7.3627 17.9165L7.36578 17.9232C7.76389 18.7918 8.18421 19.4591 8.67776 19.9115L8.67929 19.9129C9.13031 20.323 9.56138 20.5 9.96484 20.5C10.3971 20.5 10.8286 20.3284 11.2856 19.9129L11.2871 19.9115C11.7806 19.4591 12.201 18.7918 12.5991 17.9232L12.6021 17.9165L12.605 17.9097C13.0065 16.9607 13.3697 15.7972 13.5873 14.455L13.6814 13.875H13.0938H6.87109H6.28348L6.37754 14.455C6.59519 15.7972 6.95833 16.9607 7.35983 17.9097ZM7.5497 20.2016L8.9282 20.5727L8.08251 19.4226C7.26785 18.3146 6.58453 16.5021 6.2401 14.2978L6.17404 13.875H5.74609H1.63281H0.894296L1.16857 14.5607C2.28287 17.3464 4.6586 19.4232 7.5497 20.2016ZM11.8823 19.4226L11.0366 20.5727L12.4151 20.2016C15.3062 19.4232 17.682 17.3464 18.7963 14.5607L19.0705 13.875H18.332H14.2188H13.7908L13.7247 14.2978C13.3803 16.5021 12.697 18.3146 11.8823 19.4226Z"
                                stroke="white"
                              />
                            </svg>
                          </span>
                          <span className="lang-en lang-de">
                            {!isEnglishPage ? (!isMobile() ? "Englisch" : "EN") : (!isMobile() ? "German" : "DE")}
                          </span>
                        </Link>
                      </div>
                      <button
                        className={classNames(
                          "navigation__button navigation__button--inside-menu",
                          {
                            open: state.siteNav.isOpen,
                          }
                        )}
                        role="button"
                        type="menu"
                        onClick={() => {
                          dispatch({ type: "TOGGLE_SITE_NAV" });
                        }}
                      >
                        <span className="navigation__button--close">Close</span>
                      </button>
                      <div className="site-header__logo">
                        <div className="logo" role="banner">
                          <Link
                            className={classNames("logo__link")}
                            to={`/${language}`}
                            title="A fancy SEO title"
                            onClick={() => dispatch({ type: "TOGGLE_SITE_NAV" })}
                          >
                            <span className="logo__label">{nameScroll}</span>
                          </Link>
                        </div>
                      </div>
                      <div className="navigation__scroll">
                        <div className="navigation__scroll-inner">
                          <div className="navigation__menu">
                            <ul className="nav nav--header" role="presentation">
                              {menu.map(({ link, subLinks }, index) => {
                                const isSubActive = activeMainIndex === index;
                                const isActive = (link.slug && activeMainPath.includes(link.slug)) || isSubActive;
                                return (
                                  <li
                                    key={index}
                                    className={classNames("nav__item", {
                                      open: state.siteSubNav[link.slug],
                                    })}
                                  >
                                    {subLinks && subLinks.length > 0 ? (
                                      <>
                                        <label
                                          htmlFor={`navlink_${index}`}
                                          className="nav__link nav__link--hassub"
                                          title={link.sup}
                                          onClick={() => toggleIsOpen(link.slug)}
                                        >
                                          <span className="nav__link--small">
                                            {link.sup}
                                          </span>
                                          <div className={classNames("nav__text-wrap", {"active ": isActive || isSubActive})}>
                                            <span className="nav__text">
                                              {link.main}
                                            </span>
                                          </div>
                                        </label>
                                        <ul className="nav nav-sub">
                                          {subLinks.map(
                                            ({ main, slug }, index) => {
                                              const isActive = slug && activeSubPath.includes(slug);
                
                                              return (
                                              <li
                                                key={index}
                                                className="nav-sub__item"
                                              >
                                                <Link
                                                  className={classNames("nav-sub__link", {"active": isActive && activeSubPath})}
                                                  to={`/${language}/${slug}`}
                                                  title={main}
                                                  onClick={closeNav}
                                                >
                                                  {main}
                                                </Link>
                                              </li>
                                            )}
                                          )}
                                        </ul>
                                      </>
                                    ) : (
                                      <>
                                        <Link
                                          className="nav__link"
                                          to={`/${language}/${link.slug}`}
                                          title={link.sup}
                                          onClick={closeNav}
                                        >
                                          <span className="nav__link--small">
                                            {link.sup}
                                          </span>
                                          <div className={classNames("nav__text-wrap", {"active ": isActive || isSubActive})}>
                                            <span className="nav__text">
                                              {link.main}
                                            </span>
                                          </div>
                                        </Link>
                                      </>
                                    )}
                                  </li>
                                )})}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </nav>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

SiteHeader.propTypes = {
  withNavigation: PropTypes.bool,
};

SiteHeader.defaultProps = {
  withNavigation: false,
};

export const query = graphql`
  fragment SiteHeader on STRAPI_Header {
    language
    name
    nameScroll
    menuLabel
    menu {
      link {
        sup
        main
        slug
      }
      subLinks {
        main
        slug
      }
    }
  }
`;

export default SiteHeader;
